import { IconSvg } from '../types'

export const InProgress: IconSvg = (props) => {
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_306_42291)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.3158 17.8959C14.3659 17.8959 17.6491 14.6127 17.6491 10.5626C17.6491 6.51249 14.3659 3.22925 10.3158 3.22925C6.26566 3.22925 2.98242 6.51249 2.98242 10.5626C2.98242 14.6127 6.26566 17.8959 10.3158 17.8959ZM10.3158 19.8959C15.4704 19.8959 19.6491 15.7172 19.6491 10.5626C19.6491 5.40793 15.4704 1.22925 10.3158 1.22925C5.1611 1.22925 0.982422 5.40793 0.982422 10.5626C0.982422 15.7172 5.1611 19.8959 10.3158 19.8959Z"
          fill="currentColor"
        />
        <path
          d="M15.0777 10.5626C15.0777 13.1925 12.9457 15.3244 10.3158 15.3244V10.5626L10.3155 5.80068C12.9454 5.80068 15.0777 7.93265 15.0777 10.5626Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_306_42291">
          <rect
            width="20"
            height="20"
            fill="currentColor"
            transform="translate(0.320312 0.566772)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}
